export const devType = false //todo:线上false
export const localNetStation = 0;//本地环境运行项目下标
//cpsMobile 0  cpsFree  1 doudouFiction 2  youheWechat 3  weiyingyong 4
export const isTest = false //todo:测试服为true 正式服为false : 只有youheWechat需要
if(devType){
    console.log(`仅可在开发环境中，测试:${localNetStation}`)
}else{
    console.log(`可提交到服务器环境: youheWechat的cdn环境为:${isTest ? "测试服" : "正式服"}`)
}